<template>
  <div>
    <div class="pad-bot20">
      <p class="f16 width98 textalign-left dimensional">融资详情</p>
    </div>
    <div class="backwhite width100 margin-auto">
      <div class="margin20">
        <div class="table">
          <div class="leftbox" style="border-top: 1px solid #f4f5fa">
            项目名称
          </div>
          <div class="rightbox" style="border-top: 1px solid #f4f5fa">
            {{ title }}
          </div>
        </div>
        <div class="table">
          <div class="leftbox">融资单位</div>
          <div class="rightbox">{{ institution }}</div>
        </div>
        <div class="table">
          <div class="leftbox">融资方式</div>
          <div class="rightbox">{{ way }}</div>
        </div>
        <div class="table">
          <div class="leftbox">货币类型</div>
          <div class="rightbox">{{ currency }}</div>
        </div>
        <div class="table">
          <div class="leftbox">约定利率</div>
          <div class="rightbox">{{ interest_rate }}%</div>
        </div>
        <div class="table">
          <div class="leftbox">起止时间</div>
          <div class="rightbox">{{ finance_date }} 至 {{ end_time }}</div>
        </div>
        <div class="table">
          <div class="leftbox">币种</div>
          <div class="rightbox">{{ currency }}</div>
        </div>
        <div class="table">
          <div class="leftbox">备注</div>
          <div class="rightbox">{{ remark }}</div>
        </div>
      </div>
      <div class="butbox textalign-right">
        <el-button @click="dialognull()">关闭</el-button>
        <el-button type="primary" @click="primary()"> 删除 </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="80%"
      class="errorbox"
    >
      <span class="errormessage">{{ errormessage }}</span>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  entfinancedetail,
  entfinancedelete,
} from "@/api/business/business.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      title: this.title,
      institution: this.institution,
      finance_date: this.finance_date,
      way: this.way,
      currency: this.currency,
      fund: this.fund,
      interest_rate: this.interest_rate,
      end_time: this.end_time,
      remark: this.remark,
    };
  },

  methods: {
    // 删除
    inremove(index) {
      this.$confirm("此操作将删除此融资项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entfinancedelete({
            id: window.sessionStorage.getItem("Financingmodify"),
          }).then((res) => {
            if (res.data.code == 200) {
              BUS.$emit("financingadd", "yes");
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    dialognull() {
      BUS.$emit("financingadd", "yess");
    },
  },
  mounted() {
    BUS.$on("Financingmodify", (data) => {
      this.rowid = data;
      entfinancedetail({
        id: data,
      })
        .then((res) => {
          this.title = res.data.data.title;
          this.institution = res.data.data.institution;
          this.finance_date = res.data.data.finance_date;
          this.way = res.data.data.way;
          if (res.data.data.way == 1) {
            this.way = "银行贷款";
          } else if (res.data.data.way == 2) {
            this.way = "小贷公司贷款";
          } else if (res.data.data.way == 3) {
            this.way = "P2P融资";
          } else if (res.data.data.way == 4) {
            this.way = "融资租赁";
          } else if (res.data.data.way == 5) {
            this.way = "股票筹资";
          } else if (res.data.data.way == 6) {
            this.way = "债务融资";
          } else if (res.data.data.way == 7) {
            this.way = "信用担保融资";
          } else if (res.data.data.way == 8) {
            this.way = "股权融资";
          } else if (res.data.data.way == 9) {
            this.way = "增资扩股";
          } else if (res.data.data.way == 10) {
            this.way = "产权交易";
          } else if (res.data.data.way == 11) {
            this.way = "票据贴现";
          } else if (res.data.data.way == 12) {
            this.way = "贸易融资";
          } else if (res.data.data.way == 13) {
            this.way = "供应链融资";
          } else if (res.data.data.way == 14) {
            this.way = "信托融资";
          }
          if (res.data.data.currency == 1) {
            this.currency = "人民币";
          } else if (res.data.data.currency == 2) {
            this.currency = "美元";
          } else if (res.data.data.currency == 3) {
            this.currency = "现金";
          } else {
            this.currency = "其它";
          }
          this.fund = res.data.data.fund;
          this.interest_rate = res.data.data.interest_rate;
          this.end_time = res.data.data.end_time;
          this.remark = res.data.data.remark;
        })
        .catch((error) => {
          if (error.response.data.code == 401) {
            this.dialogVisiblenull = false;
            this.$router.push({ path: "/login" });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = error.response.data.msg;
          }
        });
    });
  },
  created() {
    entfinancedetail({
      id: window.sessionStorage.getItem("Financingmodify"),
    })
      .then((res) => {
        this.title = res.data.data.title;
        this.institution = res.data.data.institution;
        this.finance_date = res.data.data.finance_date;
        this.way = res.data.data.way;
        if (res.data.data.way == 1) {
          this.way = "银行贷款";
        } else if (res.data.data.way == 2) {
          this.way = "小贷公司贷款";
        } else if (res.data.data.way == 3) {
          this.way = "P2P融资";
        } else if (res.data.data.way == 4) {
          this.way = "融资租赁";
        } else if (res.data.data.way == 5) {
          this.way = "股票筹资";
        } else if (res.data.data.way == 6) {
          this.way = "债务融资";
        } else if (res.data.data.way == 7) {
          this.way = "信用担保融资";
        } else if (res.data.data.way == 8) {
          this.way = "股权融资";
        } else if (res.data.data.way == 9) {
          this.way = "增资扩股";
        } else if (res.data.data.way == 10) {
          this.way = "产权交易";
        } else if (res.data.data.way == 11) {
          this.way = "票据贴现";
        } else if (res.data.data.way == 12) {
          this.way = "贸易融资";
        } else if (res.data.data.way == 13) {
          this.way = "供应链融资";
        } else if (res.data.data.way == 14) {
          this.way = "信托融资";
        }
        if (res.data.data.currency == 1) {
          this.currency = "人民币";
        } else if (res.data.data.currency == 2) {
          this.currency = "美元";
        } else if (res.data.data.currency == 3) {
          this.currency = "现金";
        } else {
          this.currency = "其它";
        }
        this.fund = res.data.data.fund;
        this.interest_rate = res.data.data.interest_rate;
        this.end_time = res.data.data.end_time;
        this.remark = res.data.data.remark;
      })
      .catch((error) => {
        if (error.response.data.code == 401) {
          this.dialogVisiblenull = false;
          this.$router.push({ path: "/login" });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = error.response.data.msg;
        }
      });
  },
};
</script>
  
  <style scoped>
.table {
  width: 100%;
  display: flex;
  font-size: 14px;
  color: #6a7589;
  line-height: 35px;
}
.margin20 {
  margin: 20px auto 0;
}
.leftbox {
  width: 30%;
  border: 1px solid #f4f5fa;
  border-right: none;
  border-top: none;
  padding: 0 0 0 5px;
}
.rightbox {
  width: 70%;
  text-align: left;
  border: 1px solid #f4f5fa;
  border-top: none;
  padding: 0 0 0 20px;
}
.butbox {
  width: 100%;
  margin: 30px auto 0;
}
.removebtn {
  width: 60px;
  height: 26px;
  font-size: 14px;
  color: white;
  border: none;
  border-radius: 5px;
  background: #ffa138;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
  